import {
    ColorPalette,
    DEFAULT_COLORS
} from 'elements/minute/sidebar/sidebarComponents/complex/ColorPalette';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSubsection } from 'elements/minute/sidebar/sidebarSection/SidebarSubsection';
import { IIconV2WorldMarker } from 'react-give-me-map';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IIconV2WorldMarker;
    onColorChanged?: (color: string) => void;
}

export const IconMarkerStyleColorSubsection = (props: Props): JSX.Element => {
    return (
        <S_IconMarkerStyleColorSubsection className={props.className}>
            <SidebarSubsection title={Localization.COLOR} icon={{ iconName: 'palette' }}>
                <SidebarContent>
                    <ColorPalette
                        value={props.marker.elementData.generatedIconColor}
                        pickerAllowed
                        onChange={(color) => {
                            props.onColorChanged?.(color);
                        }}
                        colors={[...DEFAULT_COLORS, '#000000', '#ffffff']}
                    />
                </SidebarContent>
            </SidebarSubsection>
        </S_IconMarkerStyleColorSubsection>
    );
};

const S_IconMarkerStyleColorSubsection = styled.div``;
